import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import DatePicker from "@/components/widgets/input/DatePicker.vue"
import Dropzone from "@/components/widgets/input/Dropzone.vue"
import MoneyInput from "@/components/widgets/input/MoneyInput.vue"
import { ScopeServiceFragmentFragment, MissionLocationEnum } from "@/gql"
import type { ProjectDetailsForm } from "./types"


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectDetails',
  props: {
    service: null,
    form: null
  },
  emits: ["goto-next", "goto-prev"],
  setup(__props: any, { emit }) {

const props = __props as {
  service: ScopeServiceFragmentFragment
  form?: ProjectDetailsForm | null
}



const locations = [
  {
    value: MissionLocationEnum.Remote,
    text: "Remote",
  },
  {
    value: MissionLocationEnum.Onground,
    text: "On-ground",
  },
  {
    value: MissionLocationEnum.RemoteAndOnground,
    text: "Remote and on-ground",
  },
]



const form = ref<ProjectDetailsForm>({
  termsOfReferenceAttributes: null,
  projectLocationType: MissionLocationEnum.Remote,
  budget: {
    amount: 0,
    currency: "",
  },
  proposedEndDate: "",
  projectBrief: "",
})

const observer = ref(null)

const onSubmit = async () => {
  const validity = await (observer.value as any)?.validateWithInfo()

  if (!validity.isValid) return

  emit("goto-next", form)
}

onMounted(() => {
  if (props.form) form.value = { ...form.value, ...props.form }
})

return { __sfc: true,props, locations, emit, form, observer, onSubmit, Icon, DatePicker, Dropzone, MoneyInput }
}

})